import { Component, Input, OnInit,EventEmitter,Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ConsumeView } from 'app/models/consumeView.model';
import { BindComponentService } from 'app/utils/bind.component.service';
import { VoiceConsumeService } from '../../../services/voice.consume.service';
import { SaveConsumeComponent } from 'app/home/paraEmpresas/consume/save/content.component';
import { DataPackGroup } from '../../../models/dataPackGroup.model';
import { ConsumeService } from 'app/services/consume.service';
import { DataPackCompanyDetail } from 'app/models/dataPackCompanyDetail.model';
import { AlertService } from 'app/utils/alert.service';
import { AuthenticationService } from 'app/services/authentication.service';
import { WelComeComponent } from '../../../../app/home/paraEmpresas/consume/welcome/content.component';
import { PackageHireModalComponent } from '../../../../app/home/paraEmpresas/consume/welcome/packageHire/content.component';
import { LoadingComponent } from 'app/home/paraEmpresas/modalLoading/content.component';
import { HibridModalComponent } from './welcome/hibridModal/content.component';

import { forkJoin } from "rxjs/observable/forkJoin";
import * as _ from "lodash";
import { element } from 'protractor';

/**
 * @version $Id: content.component.ts 91275 2018-05-15 20:41:25Z eduardo.s.neto $
 */
@Component({
  templateUrl: './content.template.html',
  providers: [ConsumeView]

})
export class ConsumeComponent implements OnInit {

  static CONSUME_VOICE = 'CONSUME_VOICE';
  static CONSUME_DATA = 'CONSUME_DATA';
  static CONSUME_DATA_5G = 'CONSUME_DATA_5G';

  private static NUMBER_OF_LINES: number = 1;

  public view: ConsumeView;
  public isConsumeVoice: boolean = true;
  public openModalWelCome: string;
  public franchiseAvailableData: any;
  public franchiseAvailableData5G: any;
  public managersListData: any;
  public franchiseAvailableVoice: any;
  public franchiseConsumptionContracted: any;
  public franchiseConsumptionContracted5G: any;
  public voiceFranchiseConsumptionContracted: any;
  public managersListVoice: any;
  public isData: boolean = false;
  public isConsume5G: boolean = false;
  public isConsume4G: boolean = false;
  public managerType: string;
  public isCarregamento: boolean = false;
  public hasOverBalanceMonetaryVoice: boolean;
  public hasHibridService: boolean;
  public hasPackageHireFlag: boolean;
  public countPagnatedGroup: number;
  public isLogin: boolean = false;
  public textHibrid:string;
  public textNewService: string;
  public textWelcome: string;
  public isfilter: string;
  public typeValue: string;
  public totalLinesIn5GGroups: number = 0;
  public totalLinesIn4GGroups: number = 0;

  constructor(private router: Router,
    private consumeService: ConsumeService,
    private authenticationService: AuthenticationService,
    private bindComponent: BindComponentService,
    private modalService: NgbModal,
    private voiceConsumeService: VoiceConsumeService,
    private alertService: AlertService,
    private authService: AuthenticationService) {
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  ngOnInit() {
    this.getWelcomeText();
    //Essa variavel é inciada como true para evitar a mudança a assicrona no angular, sem setar essa variável como true o angular inicia por padrão o compoente de minutos.
    //Não se preocupem o valor será alterado assim o método getFranchiseAvailableVoice terminar, setando o valor real da variável;
    this.hasOverBalanceMonetaryVoice=true;
    this.bindComponent.subscribe(BindComponentService.VALUE_SERVICE_DATA,
      data => {
        this.hasOverBalanceMonetaryVoice  = data['hasOverBalanceMonetaryVoice'];
        this.hasHibridService = data['hasHibridService'];
      }
    );
    this.bindComponent.subscribe(BindComponentService.COUNT_PAGINATED_GROUP,
      data => {
        this.countPagnatedGroup = data;
      }
    );
    this.bindComponent.subscribe(BindComponentService.FRANCHISE_AVAILABLE_DATA_CONSUMPTION,
      franchiseAvailableData => {
        this.franchiseAvailableData  = franchiseAvailableData;
      }
    );
    this.bindComponent.subscribe(BindComponentService.FRANCHISE_AVAILABLE_DATA_CONSUMPTION_5G,
      franchiseAvailableData5G => {
        this.franchiseAvailableData5G  = franchiseAvailableData5G;
      }
    );

    this.loadingFranchiseAvailableVoice();
  }

  public redirect(andress : string) {
    this.router.navigate([andress], { queryParams: {filter:false} });
  }

  public loadingModalWelCome(){
    this.openModalWelCome="false";
    if(this.isConsumeVoice === true){
      document.getElementById('consumeVoice') && document.getElementById('consumeVoice').classList.add('active');
    }
    let data  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.hasPackageHireFlag = data['hasPackageHireFlag'];
    localStorage.setItem("HIBRID",data['isHibrid']);
    localStorage.setItem("LOGINLESS3","false");
    this.openModalWelCome = localStorage.getItem("ALREADY_OPEN")
    this.isLogin = data['totalLogin'] <= 3;
    if((data['totalLogin'] <= 3 ||this.hasHibridService || this.hasPackageHireFlag) && _.isEqual(this.openModalWelCome, "false")){
      localStorage.setItem("ALREADY_OPEN","true");
      this.openWelcomeModal();
    }
      this.isData = data['isData'];
      this.managerType = data['managerType'];
      if(!this.isData){
        document.getElementById('consumeData') && document.getElementById('consumeData').classList.add('inactive');
      }
  }

  public redirectConsumption(link: string) {

    //console.log("link",link);

    this.router.routerState.root.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      this.isfilter = params['filter'];
      this.typeValue = params['typefilter'];
    });
    if (ConsumeComponent.CONSUME_VOICE === link) {
      if(this.isConsumeVoice == true){
        this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION, true);
      }
      if(this.isfilter == 'true'){
        this.redirect('/Portal/data/consumption');
      }
      this.loadingFranchiseAvailableVoice();
      this.isConsumeVoice = true;
      this.isConsume4G = false;
      this.isConsume5G = false;
      document.getElementById('consumeVoice') && document.getElementById('consumeVoice').classList.add('active');
      document.getElementById('consumeData5g') && document.getElementById('consumeData5g').classList.remove('active');
      document.getElementById('consumeData') && document.getElementById('consumeData').classList.remove('active');
      this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION_5G_LAYOUT_ONLY, false);
    } else if (ConsumeComponent.CONSUME_DATA === link) {
      //console.log("entrou no 4G");
      if(this.isConsume4G == true){
        this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION, true);
      }
      this.loadingFranchiseAvailableVoice();
      this.isConsumeVoice = false;
      this.isConsume5G = false;
      this.isConsume4G = true;
      // Restaurar o valor original de isData do localStorage
      let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
      this.isData = data['isData'];
      document.getElementById('consumeVoice') && document.getElementById('consumeVoice').classList.remove('active');
      document.getElementById('consumeData5g') && document.getElementById('consumeData5g').classList.remove('active');
      document.getElementById('consumeData') && document.getElementById('consumeData').classList.add('active');
      this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION, this.isConsume4G);
      this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION_5G_LAYOUT_ONLY, false);
    } else if (ConsumeComponent.CONSUME_DATA_5G === link) {
      this.loadingFranchiseAvailableVoice();
      this.isConsumeVoice = false;
      this.isConsume4G = false;
      this.isConsume5G = true;
      // Restaurar o valor original de isData do localStorage
      let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
      this.isData = data['isData'];
      document.getElementById('consumeVoice') && document.getElementById('consumeVoice').classList.remove('active');
      document.getElementById('consumeData5g') && document.getElementById('consumeData5g').classList.add('active');
      document.getElementById('consumeData') && document.getElementById('consumeData').classList.remove('active');
      this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION_5G, true);
      this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION_5G_LAYOUT_ONLY, true);

      /*this.isConsumeVoice = false;
      // Não alterar isData aqui - manter o valor original
      this.isConsume5G = true;
      document.getElementById('consumeVoice').classList.remove('active');
      document.getElementById('consumeData').classList.remove('active');
      const element = document.getElementById('consumeData5g');
      if(element) {
        element.classList.add('active');
      }*/
    } else {
      this.isConsumeVoice = true;
    }
    this.bindComponent.set(BindComponentService.IS_VOICE_CONSUMPTION,  this.isConsumeVoice);
  }

  private openWelcomeModal() {
    let modalRef;
    if(this.isLogin) {
      modalRef = this.modalService.open(WelComeComponent);
      modalRef.componentInstance.isLogin = this.isLogin;
      modalRef.componentInstance.isHibrid = this.hasHibridService;
      modalRef.componentInstance.hasPackageHireFlag = this.hasPackageHireFlag;
      modalRef.componentInstance.textWelcome = this.textWelcome;
      modalRef.componentInstance.textHibrid = this.textHibrid;
      modalRef.componentInstance.textNewService = this.textNewService;
    } else if(!this.hasPackageHireFlag && this.hasHibridService){
      modalRef = this.modalService.open(HibridModalComponent);
      modalRef.componentInstance.isHibrid = this.hasHibridService;
      modalRef.componentInstance.textHibrid = this.textHibrid;
    } else {
      modalRef = this.modalService.open(PackageHireModalComponent);
      modalRef.componentInstance.calledFromLogin = true;
      modalRef.componentInstance.textHibrid = this.textHibrid
      modalRef.componentInstance.isHibrid = this.hasHibridService;
    }
  }

  private getWelcomeText() {
    let modalRef;
    this.authService.getWelcomeText().subscribe(
      data => {
        this.textWelcome = data['welcome'];
        this.textHibrid = data['hibridText'];
        this.textNewService = data['PackageHireMessage'];
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private openCreateModal() {
    this.openSaveModal();
  }

  public openSaveModal(){
   let modalRef = this.modalService.open(SaveConsumeComponent,{
      backdrop: 'static',
      keyboard: false ,
    });
    modalRef.componentInstance.mode = 'creation';
    if(!_.isNil(this.franchiseConsumptionContracted)){
      modalRef.componentInstance.companyQuotaValue = this.franchiseConsumptionContracted;
    }
    modalRef.componentInstance.isConsumedVoice = this.isConsumeVoice;
    modalRef.componentInstance.isData = this.isData;
    modalRef.componentInstance.model = { group: new DataPackGroup(),
                                         group5G: new DataPackGroup(),
                                         managersList: this.managersListData,
                                         franchiseAvailableData: this.franchiseAvailableData,
                                         franchiseAvailableVoice: this.franchiseAvailableVoice,
                                         franchiseAvailableData5G: this.franchiseAvailableData5G};
    modalRef.componentInstance.isCreateGroup  = true;
    modalRef.componentInstance.hasOverBalanceMonetaryVoice  = this.hasOverBalanceMonetaryVoice;
    modalRef.componentInstance.hasHibridService = this.hasHibridService;
    modalRef.componentInstance.voiceFranchiseConsumptionContracted  = this.voiceFranchiseConsumptionContracted;
    modalRef.result.then(result => this.loadingFranchiseAvailableVoice(), reason => null);
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
  }

  public loadingFranchiseAvailableVoice() {
    this.voiceConsumeService.getFranchiseAvailableVoice().subscribe(
      data => {
        this.franchiseAvailableVoice = data['franchiseAvailableVoice'];
        this.franchiseAvailableData = data['franchiseAvailableData'];
        this.franchiseAvailableData5G = data['franchiseAvailableData5G'];
        this.managersListData = data['managersList'];
        this.franchiseConsumptionContracted = data['franchiseConsumptionContracted'];
        this.franchiseConsumptionContracted5G = data['franchiseConsumptionContracted5G'];
        this.voiceFranchiseConsumptionContracted = data['voiceFranchiseConsumptionContracted'];
        this.hasOverBalanceMonetaryVoice = data['hasOverBalanceMonetaryVoice'];
        this.hasHibridService = data['hasHibridService'];
        this.isCarregamento=false;
        let searchVoice:any ={
          hasOverBalanceMonetaryVoice:data['hasOverBalanceMonetaryVoice'],
          hasHibridService: data['hasHibridService']
        }

        data['groupList'].forEach(element => {

          if(element.is5GPortifolio === 1){
            this.totalLinesIn5GGroups = element.totalLines + this.totalLinesIn5GGroups;
          } else {
            this.totalLinesIn4GGroups = element.totalLines + this.totalLinesIn4GGroups;
          }
        });

        this.bindComponent.set(BindComponentService.VALUE_SERVICE_VOICE,searchVoice);
        this.loadingModalWelCome();
      },
      err => {
        this.isCarregamento=false;
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/content.component.ts